import menubarContent from '../constants/menubarItems';
const normalizeSlug = (slug) => {
    return slug.endsWith('/') && slug.length > 1 ? slug.slice(0, -1) : slug;
};
const findMenuItem = (slug) => {
    const normalizedSlug = normalizeSlug(slug);
    for (const group of menubarContent) {
        if (!group.items)
            continue;
        const menuItem = group.items.find((item) => {
            if (!item.slug)
                return false;
            const normalizedItemSlug = normalizeSlug(item.slug);
            return normalizedItemSlug === normalizedSlug;
        });
        if (menuItem) {
            return menuItem;
        }
    }
    return null;
};
export const getMenuIcon = (slug) => {
    const menuItem = findMenuItem(slug);
    return (menuItem === null || menuItem === void 0 ? void 0 : menuItem.icon) || null;
};
export const getMenuLabel = (slug, t) => {
    const menuItem = findMenuItem(slug);
    if (!(menuItem === null || menuItem === void 0 ? void 0 : menuItem.name))
        return null;
    return t(`LAYOUT:${menuItem.name}`);
};
